import style, { css } from 'styled-components'

export const Iframe = style.iframe`
    ${({theme})=> css`
    width: 100%;
    height: 85vh;

`}
`